import React from "react";
import { Link, useParams } from "react-router-dom";
import TouchImage from "../../assets/images/procedures/mri_outline_1.png";
import SubSpecialitiesInfo from "../../data/SubSpecialitiesInfo";

export default function BookAnAppointment() {
  // ✅ Get slug from URL
  const { slug } = useParams();

  // ✅ Find the matching speciality dynamically
  const specialityData = SubSpecialitiesInfo.find((item) => item.slug === slug);

  return (
    <div>
      <section className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center 2xl:px-16 xl:px-10 lg:px-8 md:px-5 max-w-[80%] mx-auto py-32 mb-24">
        {/* Left side content */}
        <div className="w-full">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8 text-[#d78558] capitalize">
            {specialityData?.appointment?.title}
          </h2>
          <p className="text-lg md:text-xl text-gray-200 mb-6">
            {specialityData?.appointment?.quote}
          </p>
          <h5 className="text-xl md:text-2xl font-semibold mb-8 text-[#d78558]">
            Give us a call at:{" "}
            <Link
              to="tel:3527959200"
              aria-label="Give us a call at"
              className="text-[#d78558] hover:underline hover:text-[#fd6b6b]"
            >
              (352) 450-8062
            </Link>
          </h5>

          <Link
            data-aos="fade-right"
            to="/contact"
            aria-label="Contact us"
            className="group relative inline-flex h-14 tracking-widest items-center rounded-full px-10 py-10 text-lg md:text-xl font-semibold text-white bg-transparent overflow-hidden"
          >
            <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
              <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
              </span>
            </span>
            <span className="relative">
              <span className="flex flex-row gap-2 justify-center items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                Book an Appointment
              </span>
              <span className="absolute flex flex-row gap-2 top-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                Book an Appointment
              </span>
            </span>
          </Link>
        </div>

        {/* Right side image */}
        <div className="w-full flex justify-center">
          <img
            src={TouchImage}
            alt="Get in Touch"
            className="w-full h-auto max-w-[500px]"
          />
        </div>
      </section>
    </div>
  );
}
